import { getImageProps } from 'next/image'

import { useCdnContext } from '../cdn'

import {
  brandIllustrationGetImage,
  type BrandIllustrationName,
  type BrandIllustrationSize,
  type BrandIllustrationType,
} from './brandIllustrationGetImage'

export const useBrandIllustrationImageProps = ({
  name,
  size,
  type,
}: {
  name: BrandIllustrationName
  size: BrandIllustrationSize
  type: BrandIllustrationType
}): ReturnType<typeof getImageProps>['props'] => {
  const { visualAssetUrl } = useCdnContext()

  const image = brandIllustrationGetImage({
    cdnUrl: visualAssetUrl,
    name,
    size,
    type,
  })

  const image2x = brandIllustrationGetImage({
    cdnUrl: visualAssetUrl,
    name,
    scale: 2,
    size,
    type,
  })

  const { props: imageProps } = getImageProps({
    alt: '',
    unoptimized: true,
    ...image,
  })

  return {
    ...imageProps,
    srcSet: `${image.src}, ${image2x.src} 2x`,
  }
}
